export default {
  common: {
    confirm: '确认',
    cancel: '取消',
    close: '关闭',
    gender: {
      male: '男/M',
      female: '女/F'
    },
    money: '<currency>JPY</currency> <amount>{{amount}}</amount>',
    moneyText: 'JPY {{amount}}',
    refundMethod: {
      credit: '信用卡',
      union: '银联卡',
      alipay: '支付宝',
      wechatpay: '微信支付',
      cash: '现金'
    }
  },
  components: {
    passportCamera: {
      hint: '请将护照资料页对准框内',
      unavailable: '无法打开相机，请使用系统相机拍摄或从相册选择。',
      systemCamera: '使用系统相机',
      album: '相册',
      shoot: '拍照'
    }
  },
  views: {
    home: {
      title: '首页',
      notice: '有待返还的消费税',
      apply: '免税申请',
      historyTitle: '申请记录',
      total: '总额',
      refundAmount: '预计退款',
      empty: '暂无申请记录',
      loadError: '加载失败，请稍后重试。',
      applyError: '申请提交失败，请稍后重试。',
      status: {
        awaitingCustoms: '等待海关确认',
        notEligible: '不符合退税条件',
        refunding: '退税处理中',
        refunded: '退税成功',
        refundFailed: '退税失败'
      }
    },
    landing: {
      title: '日本免税退税服务',
      description: '出境确认后，您通过 URL\n访问了本服务',
      next: '下一步'
    },
    login: {
      title: '日本免税退税服务',
      google: '使用 Google 登录',
      email: '使用邮箱登录',
      emailLabel: '邮箱地址',
      sendLink: '发送登录链接',
      resendLink: '重新发送登录链接',
      linkSent: '登录链接已发送至 {{email}}。\n请查收邮件。',
      confirmEmail: '请重新输入邮箱地址以完成登录。',
      submit: '登录',
      loginError: '登录失败，请稍后再试。',
      sendError: '发送失败，请稍后再试。'
    },
    passportInfo: {
      title: '护照信息',
      nationality: '国籍',
      passportNumber: '护照号码',
      lastName: '姓',
      firstName: '名',
      gender: '性别',
      dateOfBirth: '出生日期',
      dateOfExpiry: '有效期',
      confirm: '确认',
      rescan: '识别有误・重新拍摄',
      scanError: '无法识别护照，请重新拍摄。',
      bindError: '添加失败，请稍后再试。'
    },
    passports: {
      title: '护照列表',
      add: '添加新护照',
      empty: '请添加护照',
      pending: '{{num}}笔未申请',
      delete: '删除',
      deleteConfirm: '确定删除护照 {{number}} 吗？',
      loadError: '加载失败，请稍后再试。',
      deleteError: '删除失败，请稍后再试。',
      selectError: '切换护照失败，请稍后再试。',
      logout: '退出登录'
    },
    taxInfo: {
      title: '填写退税单据信息',
      passportLabel: '护照号码',
      passportPlaceholder: '请输入',
      lastNameLabel: '姓',
      lastNamePlaceholder: '请输入',
      firstNameLabel: '名',
      firstNamePlaceholder: '中间名和名',
      expiryLabel: '护照有效期',
      verifyError: '护照信息核对失败，请检查输入内容。',
      submit: '核对并继续'
    },
    residenceCert: {
      title: '在留资格证明书',
      notice: '为确认您已在海外居住 2 年以上，请提交以下任意一种证明文件。',
      documentLabel: '海外居住证明（任选 1 项）',
      types: {
        permitDocumentTypeKosekiFukuhyo: '户籍附票',
        permitDocumentTypeResidenceCertificate: '海外在留证明',
        permitDocumentTypeMynumberCard: '个人编号卡'
      },
      residenceStatusLabel: '在留资格',
      residenceStatusPlaceholder: '请选择',
      permitTypes: {
        shipTourism: '船舶观光上陆',
        crew: '乘员上陆',
        emergency: '紧急上陆',
        distress: '遇难上陆',
        sofa: '美军人员',
        portCall: '寄港地上陆',
        transit: '过境上陆'
      },
      entryDateLabel: '入境日',
      settledDateLabel: '海外定居日',
      datePlaceholder: 'yyyy-mm-dd',
      addressLabel: '海外居住地',
      countryPlaceholder: '请选择',
      uploadLabel: '上传图片',
      capture: '拍摄',
      removeImage: '删除图片',
      submit: '上传',
      verifyError: '链接无效或已过期，请重新扫码。'
    },
    uploadResult: {
      title: '上传结果',
      done: '上传完成',
      desc: '请返回 Kiosk 继续操作',
      failed: '上传失败',
      failedDesc: '请重新操作'
    },
    statusDetail: {
      title: '申请状态详情',
      orderNo: '订单号 {{id}}',
      appliedAt: '申请日期 {{date}}',
      appliedAt_method: '申请日期 {{date}}｜{{method}}',
      total: '总额',
      taxAmount: '税额',
      refundFee: '手续费',
      refundAmount: '预计退款',
      customsNotice:
        '出境时请在海关接受所购商品的确认。确认完成后将开始退款处理。',
      steps: {
        received: '申请受理完成',
        customsPending: '海关出境确认中',
        customs: '海关出境确认完成',
        customsFailed: '海关审核未通过',
        refunding: '退款处理中',
        refunded: '退款完成',
        refundFailed: '退款失败'
      },
      remitNote: '通常 3〜5 个工作日',
      retry: '重新申请',
      retryError: '重新申请失败，请稍后再试。',
      loading: '加载中...',
      loadError: '加载失败，请稍后再试。'
    },
    notFound: {
      title: '页面不存在',
      description: '您访问的页面不存在或已被移动。',
      backHome: '返回首页'
    }
  }
};
